var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"350px"}},[_c('mapbox',{attrs:{"locations":_vm.locations},on:{"map-clicked":_vm.mapClicked,"zoom":function($event){_vm.zoom=$event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }